export default __webpack_public_path__ + "static/media/sprite_footer_01.7716863c.png";